"use client";

import Link from "next/link";
import { useMemo } from "react";
import Slider from "@/components/ui/slider";
import { Card, CardContent } from "@/components/ui/card";
import type { Category } from "@/types/category";


type Props = {
    categories: Category[];
    currentCategory?: Category | null;
};

export default function SubMenuCategoryPost({
                                    categories,
                                    currentCategory,
                                }: Props) {
    const filteredCategories = useMemo(() => {
        const base = currentCategory
            ? categories.filter(cat => cat.parent_id === currentCategory.id)
            : categories.filter(cat => cat.parent_id === 0);

        const labels = base.filter(c => c.style === "label");

        return labels.length ? labels : base;
    }, [categories, currentCategory]);

    if (!filteredCategories.length) return <div className="py-3" />;

    return (
        <div className={'flex flex-wrap items-center justify-between gap-4 mb-3 flex-col lg:flex-row lg:items-center bg-white shadow-sm p-3 rounded-lg'}>
            <Slider items={4}>
                {filteredCategories.map(cat => (
                    <Card key={cat.id}
                          className="flex flex-col shadow-none border hover:bg-gray-200 transition">
                        <CardContent className="p-0 text-center">
                            <Link
                                href={`/${process.env.NEXT_PUBLIC_BLOG_CATEGORY}/${cat.slug}`}
                                className="block text-sm p-4 font-medium text-gray-800"
                                prefetch={true}
                            >
                                {cat.title}
                            </Link>
                        </CardContent>
                    </Card>
                ))}
            </Slider>
        </div>
    );
}